/**
 * Product Grid Simple — Swiper + flechas (no depende del bundle {% javascript %} de Shopify).
 * Carga: theme.liquid después de swiper-bundle.min.js
 */
(function () {
  var TW_PGS_DEBUG = true;
  function log() {
    if (TW_PGS_DEBUG && typeof console !== 'undefined' && console.log) {
      console.log.apply(console, ['[TW PGS]'].concat([].slice.call(arguments)));
    }
  }

  function toBool(v) {
    return String(v) === 'true' || String(v) === '1';
  }

  function initSwiper(sectionRoot) {
    var el = sectionRoot.querySelector('[data-pgs-swiper]');
    if (!el) return false;
    if (!window.Swiper) {
      log('initSwiper: esperando window.Swiper…');
      return false;
    }

    if (el.__pgsSwiper) {
      try {
        el.__pgsSwiper.destroy(true, true);
      } catch (e) {}
      el.__pgsSwiper = null;
    }

    var prev = sectionRoot.querySelector('[data-pgs-prev]');
    var next = sectionRoot.querySelector('[data-pgs-next]');
    var pagination = sectionRoot.querySelector('[data-pgs-pagination]');
    
    log('Looking for elements - prev:', prev, 'next:', next, 'pagination:', pagination);

    var spvM = parseFloat(el.dataset.spvM || 1);
    var spvT = parseFloat(el.dataset.spvT || 2);
    var spvD = parseFloat(el.dataset.spvD || 3);
    var gap = Number(el.dataset.gap || 16);
    var loop = toBool(el.dataset.loop);
    var autoplayEnabled = toBool(el.dataset.autoplay);
    var speed = Number(el.dataset.speed || 3000);
    var effect = el.dataset.effect || 'slide';
    var speedTransition = Number(el.dataset.speedTransition || 300);
    var centered = toBool(el.dataset.centered);
    var grab = toBool(el.dataset.grab);
    var freeMode = toBool(el.dataset.freeMode);
    var pauseOnHover = toBool(el.dataset.pauseOnHover);

    var cfg = {
      slidesPerView: spvM,
      spaceBetween: gap,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      speed: speedTransition,
      effect: effect,
      centeredSlides: centered,
      grabCursor: grab,
      freeMode: freeMode,
      loop: loop,
      breakpoints: {
        768: { slidesPerView: spvT, centeredSlides: centered, spaceBetween: gap },
        1024: { slidesPerView: spvD, centeredSlides: centered, spaceBetween: gap },
      },
    };

    if (prev && next) cfg.navigation = { prevEl: prev, nextEl: next };
    if (pagination) cfg.pagination = { el: pagination, clickable: true };
    if (autoplayEnabled)
      cfg.autoplay = { delay: speed, disableOnInteraction: false, pauseOnMouseEnter: pauseOnHover };

    if (effect === 'fade') cfg.fadeEffect = { crossFade: true };
    else if (effect === 'cube')
      cfg.cubeEffect = { shadow: true, slideShadows: true, shadowOffset: 20, shadowScale: 0.94 };
    else if (effect === 'coverflow')
      cfg.coverflowEffect = { rotate: 50, stretch: 0, depth: 100, modifier: 1, slideShadows: true };
    else if (effect === 'flip') cfg.flipEffect = { slideShadows: true, limitRotation: true };

    el.__pgsSwiper = new window.Swiper(el, cfg);
    log('Swiper OK', {
      slides: el.querySelectorAll('.swiper-slide').length,
      spv: { m: spvM, t: spvT, d: spvD },
      hasNav: !!(prev && next),
    });

    [50, 200, 500].forEach(function (ms) {
      setTimeout(function () {
        if (el.__pgsSwiper) el.__pgsSwiper.update();
      }, ms);
    });

    return true;
  }

  function bootAll() {
    var roots = document.querySelectorAll('.product-grid-simple');
    for (var r = 0; r < roots.length; r++) {
      (function (root) {
        var el = root.querySelector('[data-pgs-swiper]');
        if (!el) return;
        var tries = 0;
        var t = setInterval(function () {
          tries++;
          if (initSwiper(root) || tries > 40) {
            if (tries > 40) {
              var inner = root.querySelector('[data-pgs-swiper]');
              if (inner && !inner.__pgsSwiper) {
                log('bootAll: Swiper no disponible tras reintentos (usa fallback scroll)');
              }
            }
            clearInterval(t);
          }
        }, 100);
      })(roots[r]);
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('[data-pgs-prev],[data-pgs-next]');
      if (!btn) return;
      var root = btn.closest('.product-grid-simple');
      if (!root) return;
      var swiperEl = root.querySelector('[data-pgs-swiper]');
      if (!swiperEl) {
        log('arrow click: no [data-pgs-swiper]');
        return;
      }

      var sw = swiperEl.__pgsSwiper;
      if (sw) {
        e.preventDefault();
        var isPrev = btn.hasAttribute('data-pgs-prev');
        log('arrow click → Swiper API', {
          isPrev: isPrev,
          isBeginning: sw.isBeginning,
          isEnd: sw.isEnd,
          activeIndex: sw.activeIndex,
        });
        if (isPrev) sw.slidePrev();
        else sw.slideNext();
        return;
      }

      if (swiperEl.classList.contains('swiper-initialized')) {
        log('arrow click: swiper-initialized pero sin __pgsSwiper (estado raro)');
        return;
      }

      e.preventDefault();
      log('arrow click → scroll fallback (Swiper no cargó)');

      var dir = btn.hasAttribute('data-pgs-prev') ? -1 : 1;
      var gap = Number(swiperEl.dataset.gap || 16);
      var spvM = parseFloat(swiperEl.dataset.spvM || 1) || 1;
      var spvT = parseFloat(swiperEl.dataset.spvT || 2) || 2;
      var spvD = parseFloat(swiperEl.dataset.spvD || 3) || 3;
      var vw = window.innerWidth || document.documentElement.clientWidth || 0;
      var spv = vw >= 1024 ? spvD : vw >= 768 ? spvT : spvM;
      var cardW = Math.max(
        1,
        (swiperEl.clientWidth - (Math.max(spv, 1) - 1) * gap) / Math.max(spv, 1)
      );
      var before = swiperEl.scrollLeft;
      swiperEl.scrollBy({ left: (cardW + gap) * dir, behavior: 'smooth' });
      log('scrollBy', { before: before, delta: (cardW + gap) * dir, after: swiperEl.scrollLeft });
    },
    true
  );

  document.addEventListener('shopify:section:load', function (e) {
    var root = document.querySelector('.product-grid-simple-' + e.detail.sectionId);
    if (root) setTimeout(function () { initSwiper(root); }, 150);
  });
  document.addEventListener('shopify:section:select', function (e) {
    var root = document.querySelector('.product-grid-simple-' + e.detail.sectionId);
    if (root) setTimeout(function () { initSwiper(root); }, 150);
  });

  bootAll();
})();
